module.exports = __webpack_public_path__ + "img/closeEye.76a763c5.svg";